
import React, { Component } from 'react';
import axios from 'axios';
import {API_URL} from '../../constants';
import {BASE_URL_RUEDAS} from '../../constants';

export default class Calendario extends Component {

    
constructor(props) {
    super(props);
    this.state = { 
        resource: [],
        response: [],
        section: [],
        error: [],
        key: 0,
        sectorKey: this.props.sector,
        cssClass:''
      }
  }

  
    componentDidMount=()=> {
        var url = `${API_URL}EventUX/${this.state.sectorKey}`; 
        axios.get(url).then(response => response.data)
        .then((data) => {
          this.setState({ section: data.result, error: data.Error });
        })
        .catch(error => {
          console.log(error);
        });
    }

    render() {
        var urlEventsImage = `${BASE_URL_RUEDAS}/Handler/DocumentManager.ashx?nombreArchivoFoto=`; 
        return ( 
            (this.state.response.statusCode==200)?
            (
            <div className="events gray-bg-semi-dark">
            <div className="boletin__section">
                <div className="boletin__section">
                    <ul id="boletin__header-title">
                        <li className="boletin__subtitle-name ">
                        <span className="boletin__subtitle-name--pl">CALENDARIO</span>
                        </li>
                    </ul>
                </div>
                <div className="boletin__section white-bg events__links-section">
                    <ul className="nav">
                        <li className="nav-item boletin__nav-item">
                            <a className="nav-link active boletin__nav-link boletin__nav-link--active" href="#"> PRÓXIMOS</a>
                        </li>
                        {/* <li className="nav-item boletin__nav-item">
                            <a className="nav-link boletin__nav-link" href="#"> INFORMES COMERCIALES </a>
                        </li>         */}
                        {/* <li className="nav-item boletin__nav-item ml-auto">
                            <a className="nav-link events__todos" href="#">VER TODOS<i className="events__todos-arrow fas fa-arrow-right"></i>
                            </a>
                        </li> */}
                    </ul>
                </div>
                <div className="boletin__section">
                    {/* Proximos */}
                    <div className="events-row">
                        <div id="carousel-events" className="carousel-multi carousel slide" data-ride="carousel" data-touch="true">
                            <div className="carousel-multi carousel-inner row w-100 mx-auto" role="listbox">
                                {/* Lista de Eventos */}
                                {this.state.section.map((section, index) => (
                                <div className="carousel-multi carousel-item col-12 col-sm-6 col-md-4 col-lg-3 active" key={section.id_evento}>
                                    <div className="card event-item__card mx-auto d-block">
                                        <img className="event-item__card-img" src={urlEventsImage + section.tx_documento_flyer} alt="Evento" />
                                            <div className="card-body event-item__body">
                                                <p className="card-title event-item__title">{section.de_evento}</p>
                                            </div>
                                            <div className="card-footer event-item__footer">
                                                <a target="_blank" href={BASE_URL_RUEDAS + 'publico/es/' + section.de_ruta} className="d-flex bd-highlight new-opportunity__more-info-link">
                                                    <span className="bd-highlight new-opportunity__more-info-text">{section.fh_fin}</span>
                                                    <span className="ml-auto bd-highlight event-item__more-info-arrow"><i className="fas fa-chevron-right"></i></span>
                                                </a>
                                            </div>
                                     </div>
                                </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>):
            (<div>
                <div className="events gray-bg-semi-dark">
                    <div className="boletin__section">
                        <div className="boletin__section">
                            <ul id="boletin__header-title">
                                <li className="boletin__subtitle-name ">
                                <span className="boletin__subtitle-name--pl">CALENDARIO</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="row last-news-sector__row"  id="contentNews" >
                        <div className="last-news-sector__main col-sm-6">
                        
                        </div>
                    </div>
                </div>
            </div>)
        )
    }

}